<ng-container *ngFor="let letter of lettering">
  <!-- <div class="lettering" *ngIf="letter?.id <= index" @fadeAnimation [@slideInOut]="letter?.state"> -->
  <div class="lettering" *ngIf="letter?.id <= index">
    <mat-icon>{{ letter?.icon }}</mat-icon>
    {{ letter?.message }}
  </div>
</ng-container>